import Helmet from 'react-helmet';

const TitleComponent = (props:any) => {
    const {title, description,keywords} = props;
    return (
        <Helmet>
            <title>{title ? title : 'Portal DN Power BI'}</title>
            <meta name='description' content={description ? description :''} />
            <meta name='keywords' content={keywords ? keywords :''} />
        </Helmet>
    );
};

export default TitleComponent;